import React from 'react';
import IndicarPage from './pages/IndicarPage';
import CursoLandingPage from './pages/CursoLandingPage';
import BarraCurso from './components/BarraCurso';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import LandingPage from './pages/LandingPage';
import EspiritoLivrePage from './pages/EspiritoLivrePage';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import StorePage from './pages/StorePage';
import EventsPage from './pages/EventsPage';
import DigitalIDPage from './pages/DigitalIDPage';
import SOSPage from './pages/SOSPage';
import AdminDashboard from './pages/AdminDashboard';
import GamificationPage from './pages/GamificationPage';
import MadrinhaPage from './pages/MadrinhaPage';
import ProfilePage from './pages/ProfilePage';
import ManutencaoMotoPage from './pages/ManutencaoMotoPage';
import SocialMediaPage from './pages/SocialMediaPage';
import DocumentsPage from './pages/DocumentsPage';
import ComandoBrasilPage from './pages/ComandoBrasilPage';
import ConvocacoesPage from './pages/ConvocacoesPage';
import LivroCaixaPage from './pages/LivroCaixaPage';
import AdminProductsPage from './pages/AdminProductsPage';
import ParceirosPage from './pages/ParceirosPage';
import PublicStorePage from './pages/PublicStorePage';
import FlyersPage from './pages/FlyersPage';
import MirimPage from './pages/MirimPage';
import SaaSLandingPage from './pages/SaaSLandingPage';
import AdminSaaSPage from './pages/AdminSaaSPage';
import SolicitarDivisaoPage from './pages/SolicitarDivisaoPage';
import TenantLandingPage from './pages/TenantLandingPage';
import ApoiarPage from './pages/ApoiarPage';
import AdminAcoesSociaisPage from './pages/AdminAcoesSociaisPage';
import TermosUsoPage from './pages/TermosUsoPage';
import PrivacidadePage from './pages/PrivacidadePage';
import LeisSorrisoPage from "./pages/LeisSorrisoPage";
import PagarMensalidadePage from './pages/PagarMensalidadePage';
import PagarInscricaoPage from './pages/PagarInscricaoPage';
import CursoRegistroPage from './pages/CursoRegistroPage';
import CursoGratisPage from "./pages/CursoGratisPage";
import AreaAlunoPage from "./pages/AreaAlunoPage";
import AdminPagamentosCursoPage from "./pages/AdminPagamentosCursoPage";
import InstallPWABanner from './components/InstallPWABanner';
import ForceResetPasswordGate from './components/ForceResetPasswordGate';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './App.css';
import AdminPainelPage from "./pages/AdminPainelPage";
import AdminMetricasPage from "./pages/AdminMetricasPage";

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#E2B84A]"></div>
      </div>
    );
  }
  
  if (!user) return <Navigate to="/login" />;
  return children;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#E2B84A]"></div>
      </div>
    );
  }
  
  if (!user || (user.role !== 'admin' && user.role !== 'diretoria')) return <Navigate to="/dashboard" />;
  return children;
}

function AppRoutes() {
  return (
    <Router>
      <InstallPWABanner />
      <BarraCurso />
      <Routes>
        <Route path="/" element={<CursoLandingPage />} />
        <Route path="/espirito-livre" element={<Navigate to="/" replace />} />
        <Route path="/loja-publica" element={<PublicStorePage />} />
        <Route path="/register" element={<Navigate to="/" replace />} />
        <Route path="/r/:matriculaParam" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<Navigate to="/curso/aluno" replace />} />
        <Route path="/store" element={<Navigate to="/" replace />} />
        <Route path="/events" element={<Navigate to="/" replace />} />
        <Route path="/digital-id" element={<Navigate to="/" replace />} />
        <Route path="/sos" element={<Navigate to="/" replace />} />
        <Route path="/ranking" element={<Navigate to="/" replace />} />
        <Route path="/madrinha" element={<Navigate to="/" replace />} />
        <Route path="/profile" element={<Navigate to="/" replace />} />
          <Route path="/manutencao-moto" element={<Navigate to="/" replace />} />
        <Route path="/pagar-mensalidade" element={<Navigate to="/" replace />} />
        <Route path="/pagar-inscricao" element={<Navigate to="/" replace />} />
        <Route path="/social" element={<Navigate to="/" replace />} />
        <Route path="/documents" element={<Navigate to="/" replace />} />
        <Route path="/comando-brasil" element={<Navigate to="/" replace />} />
        <Route path="/convocacoes" element={<Navigate to="/" replace />} />
        <Route path="/livro-caixa" element={<AdminRoute><LivroCaixaPage /></AdminRoute>} />
        <Route path="/admin/products" element={<AdminRoute><AdminProductsPage /></AdminRoute>} />
        <Route path="/admin/acoes-sociais" element={<Navigate to="/" replace />} />
        <Route path="/parceiros" element={<Navigate to="/" replace />} />
        <Route path="/flyers" element={<Navigate to="/" replace />} />
        <Route path="/mirim" element={<Navigate to="/" replace />} />
        <Route path="/solicitar-divisao" element={<Navigate to="/" replace />} />
        <Route path="/saas" element={<Navigate to="/" replace />} />
          <Route path="/admin/metricas" element={<AdminRoute><AdminMetricasPage /></AdminRoute>} />
          <Route path="/admin/painel" element={<AdminRoute><AdminPainelPage /></AdminRoute>} />
          <Route path="/admin/pagamentos-curso" element={<AdminRoute><AdminPagamentosCursoPage /></AdminRoute>} />
          <Route path="/curso/aluno" element={<AreaAlunoPage />} />
        <Route path="/curso/gratis" element={<CursoGratisPage />} />
        <Route path="/indicar" element={<IndicarPage />} />
        <Route path="/curso/comprar/1" element={<Navigate to="/curso/gratis" replace />} />
        <Route path="/curso/comprar/:modulo" element={<CursoRegistroPage />} />
        <Route path="/m/:slug" element={<Navigate to="/" replace />} />
        <Route path="/m/:slug/cadastro" element={<Navigate to="/" replace />} />
        <Route path="/apoiar" element={<Navigate to="/" replace />} />
        <Route path="/termos" element={<TermosUsoPage />} />
        <Route path="/privacidade" element={<PrivacidadePage />} />
        <Route path="/leis-sorriso" element={<LeisSorrisoPage />} />
        <Route path="/admin/saas" element={<Navigate to="/" replace />} />
        <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      </Routes>
      <Toaster position="top-right" richColors />
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <div className="App dark">
        <AppRoutes />
      </div>
    </AuthProvider>
  );
}

export default App;